import React from "react";
import { languagesList } from "../dummy-data/languages";

export default function DisplayLanguages({ userData }) {
	return (
		<div className="mb-2">
			<p className="mt-3">
				<i className="bi bi-translate"></i> <span>Languages</span>
			</p>

			{userData?.languages?.map((languageName) => {
				const language = languagesList.find((lang) => lang.name === languageName);
				return (
					<span key={languageName} className="badge custom-badge rounded-pill text-bg-secondary me-2 mb-1">
						{languageName === "Catalan" ? (
							<span className="me-1">
								<img src="/images/Flag_of_Catalonia.svg.png" alt="Catalan Flag" className="me-1 catalan-flag" />
								{languageName}
							</span>
						) : (
							<>
								<span className="me-1">{language?.flag}</span>
								<span>{languageName}</span>
							</>
						)}
					</span>
				);
			})}

			{!userData?.languages?.length && <div>(Add languages you can speak)</div>}
		</div>
	);
}
